import { IMessage } from "@microdoing/shared/services/message/types";
import { IFileToUploadType } from "@microdoing/shared/services/upload/types";
import hasAudioExtension from "@microdoing/shared/utils/hasAudioExtension";
import { PressableOpacity } from "app/components/common";
import PaperPlaneIcon from "app/components/Icons/PaperPlaneIcon";
import theme from "app/Theme/Theme";
import React, { useEffect } from "react";
import { StyleSheet, TouchableOpacity, View, Text } from "react-native";

const styles = StyleSheet.create({
  main: {
    width: 40,
    paddingRight: 10,
    height: "100%",
    flexDirection: "row",
    alignContent: "center",
    justifyContent: "center",
  },
  icons: {
    flex: 10,
    paddingBottom: 6,
    flexDirection: "row",
    alignContent: "center",
    justifyContent: "center",
    marginRight: 15,
  },
  sendMessage: {
    width: 100,
    paddingRight: 10,
    display: "flex",
    justifyContent: "center",
  },
});

interface Props {
  onSend: (
    messages: Partial<IMessage> | Partial<IMessage>[],
    shouldResetInputToolbar?: boolean,
  ) => void | undefined;
  text: string;
  filesToUpload: IFileToUploadType[];
}

const ChatSend = ({ onSend, text, filesToUpload, ...rest }: Props) => {
  const isAudio = hasAudioExtension(
    filesToUpload?.[0]?.uri,
    filesToUpload?.[0]?.fileName,
  );

  return (
    (text !== "" || (filesToUpload.length > 0 && !isAudio)) && (
      <View style={styles.main}>
        <PressableOpacity
          hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
          style={{
            alignItems: "center",
            justifyContent: "center",
            alignSelf: "center",
            height: 50,
          }}
          onPress={onSend}
        >
          <PaperPlaneIcon color={theme.colors["brand.500"]} />
        </PressableOpacity>
      </View>
    )
  );
};

export default ChatSend;
